const carouselItems = [
  {
    title: '2024年度最受欢迎国漫TOP10',
    desc: '盘点今年最火爆的国产漫画，仙侠、都市、奇幻类作品强势霸榜，快来看看你追的上榜了没。',
    tag: '年度盘点',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20Chinese%20ink%20painting%20style%20landscape%20with%20mountains%20and%20clouds%20in%20warm%20coral%20tones%2C%20modern%20minimalist%20composition%2C%20soft%20gradients%2C%20dreamy%20atmosphere%2C%20editorial%20design&width=800&height=500&seq=carousel-01&orientation=landscape',
    date: '2024-12-20',
  },
  {
    title: '韩漫热潮：这些作品为什么火爆全网',
    desc: '从《女神降临》到《入赘女婿》，韩漫凭借精致的画风和紧凑的剧情收割全球读者。',
    tag: '韩漫专题',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20illustration%20style%20with%20stylized%20characters%20in%20warm%20peach%20tones%2C%20soft%20romantic%20atmosphere%2C%20clean%20composition%20with%20gentle%20color%20gradients%2C%20editorial%20quality&width=800&height=500&seq=carousel-02&orientation=landscape',
    date: '2024-12-18',
  },
  {
    title: '下拉式阅读 vs 翻页式：哪种更适合你',
    desc: '对比两种主流漫画阅读模式，下拉式凭借连贯流畅的体验正在成为新一代读者的首选。',
    tag: '阅读指南',
    img: 'https://readdy.ai/api/search-image?query=Clean%20modern%20minimalist%20illustration%20of%20a%20digital%20device%20displaying%20colorful%20comic%20panels%2C%20warm%20amber%20accents%2C%20soft%20background%20with%20geometric%20shapes%2C%20editorial%20style&width=800&height=500&seq=carousel-03&orientation=landscape',
    date: '2024-12-15',
  },
  {
    title: '新人必看：漫画入门推荐清单',
    desc: '初次接触漫画不知道从哪看起？这份入门清单涵盖各类题材经典作品，帮你快速找到心头好。',
    tag: '新手指南',
    img: 'https://readdy.ai/api/search-image?query=Warm%20inviting%20illustration%20of%20stacked%20colorful%20books%20and%20comics%20with%20soft%20lighting%2C%20coral%20and%20cream%20color%20palette%2C%20cozy%20reading%20nook%20atmosphere%2C%20editorial%20quality&width=800&height=500&seq=carousel-04&orientation=landscape',
    date: '2024-12-10',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-500">深度内容精选，带你发现漫画世界的精彩</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:scale-[1.02] transition-transform"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 mb-3">{item.desc}</p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  <span>{item.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}